<script>

  import Languages from "../../lang/lang";

  export default {
    name: "Summary",
    props: ['userData'],
    data: function () {
      return {
        openWithdrawal: window['openWithdrawal'],
        timer: 0,
        todayLeft: 24 * 60 * 60 * 1000 - new Date().getTime() % (24 * 60 * 60 * 1000),
        totalIncomeHintVisible: false
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.todayLeft = 24 * 60 * 60 * 1000 - new Date().getTime() % (24 * 60 * 60 * 1000);
      }, 1000);
    },
    beforeUnmount() {
      clearInterval(this.timer);
    },
    computed: {
      lang() {
        return Languages.texts('summary');
      },
      yesterday() {
        return this.userData.yesterdayIncome;
      },
      yesterdayUsd() {
        if (this.userData.yesterdayIncome > 0) {
          return window['formatBigDollar'](this.userData.yesterdayIncome * this.userData.btcPrice, 2);
        } else {
          return this.userData.yesterdayIncome;
        }
      },
      totalIncome() {
        return this.userData.totalIncome.toFixed(8);
      },
      totalIncomeUsd() {
        return window['formatBigDollar'](this.userData.totalIncome * this.userData.btcPrice, 2);
      },
      withdrawn() {
        return this.userData.withdrawn == null ? (Number(0).toFixed(8)) : this.userData.withdrawn.toFixed(8);
      },
      withdrawnUsd() {
        return window['formatBigDollar'](this.userData.withdrawn * this.userData.btcPrice, 2);
      },
      balance() {
        return this.userData.unpaidBalance.toFixed(8);
      },
      balanceUsd() {
        return window['formatBigDollar'](this.userData.unpaidBalance * this.userData.btcPrice, 2);
      },
      todayTimeLeft() {
        const hours = String(Math.floor(this.todayLeft / (1000 * 60 * 60))).padStart(2, '0');
        const minutes = String(Math.floor((this.todayLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
        const seconds = String(Math.floor((this.todayLeft % (1000 * 60)) / 1000)).padStart(2, '0');
        return hours + ':' + minutes + ':' + seconds;
      },
      todayPassed() {
        let percentage = this.todayLeft / (24 * 60 * 60 * 1000);
        return Math.min(264 * percentage, 263);
      },
      todayIncome() {
        if (this.userData.pendingTodayIncome == null || this.userData.pendingTodayIncome === 0) return null;
        return ((1 - this.todayLeft / (24 * 60 * 60 * 1000)) * this.userData.pendingTodayIncome).toFixed(12);
      },
      todayIncomeUsd() {
        if (this.userData.pendingTodayIncome == null || this.userData.pendingTodayIncome === 0) return null;
        return (
            (1 - this.todayLeft / (24 * 60 * 60 * 1000)) * this.userData.pendingTodayIncome * this.userData.btcPrice
        ).toFixed(6) + ' $';
      }
    }
  }
</script>

<template>
  <div class="summary">
    <div class="blocks">
      <div class="pre-block">
        <div class="block-title">
          {{ lang['income'] }}
        </div>
        <div :class="'block ' + (todayIncome != null ? 'block-income' : '')">
          <div>
            <template v-if="todayIncome != null">
              <div class="item-title">{{ lang['todayEstimate'] }}</div>
              <div class="item-value btc gold-gradient">
                <span>
                  {{ todayIncome }} BTC
                </span>
              </div>
              <div class="item-value usd">&asymp; {{ todayIncomeUsd }}</div>
            </template>

            <div class="item-title">{{ lang['yesterday'] }}:</div>
            <div class="item-value btc green-gradient">
              <span>
                {{ yesterday }} BTC
              </span>
            </div>
            <div class="item-value usd">&asymp; {{ yesterdayUsd }}</div>
          </div>
          <svg width="108" height="108" viewBox="0 0 108 108" fill="none" v-if="todayIncome != null"
               xmlns="http://www.w3.org/2000/svg">
            <circle cx="54" cy="54" r="42" stroke="url(#greenFill)" stroke-width="24" />
            <g id="progress" style="transform: rotate(-90deg); transform-box: fill-box; transform-origin: center;"
               filter="url(#shadow)">
              <circle cx="54" cy="54" r="42" stroke="url(#goldFill)" stroke-width="24" stroke-linecap="round"
                      :style="'stroke-dasharray: 264; stroke-dashoffset: ' + todayPassed + ';'"/>
            </g>
            <path d="M54 7L59 12L54 17" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <path d="M49 12L59 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <defs>
              <filter id="shadow" x="-2" y="-2" width="4" height="4">
                <feOffset result="offOut" in="SourceAlpha" />
                <feColorMatrix type="matrix" in="offOut" result="matrixOut"
                               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
                <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
              </filter>
              <linearGradient id="greenFill" x1="0" y1="6" x2="113.906" y2="12.6373" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#B2FF8E"/>
                <stop offset="1" stop-color="#47B3AC"/>
              </linearGradient>
              <linearGradient id="goldFill" x1="-6" y1="42" x2="-8.67388" y2="86.0763" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#FFF48E"/>
                <stop offset="1" stop-color="#FBB03B"/>
              </linearGradient>
            </defs>
          </svg>
          <div class="item-total">
            <div :class="'item-title ' + (todayIncome != null ? 'with-hint' : '')">
              {{ lang['total'] }}
              <!--<div class="hint" @click="totalIncomeHintVisible = true"
                   v-if="todayIncome != null && !totalIncomeHintVisible">!</div>-->
            </div>
            <div class="item-hint" v-if="totalIncomeHintVisible">
              {{ lang['totalIncomeHint1'] }}<br/>
              {{ lang['totalIncomeHint2'] }}
            </div>
            <div class="item-value btc"><div>{{ totalIncome }} BTC</div></div>
            <div class="item-value usd">&asymp; {{ totalIncomeUsd }}</div>
          </div>

          <div class="buttons">
            <router-link to="/income" class="button btn btn-simple">
              {{ lang['incomeHistory'] }}
            </router-link>
          </div>
        </div>
      </div>

      <div class="pre-block">
        <div class="block-title">
          {{ lang['finance'] }}
        </div>
        <div class="block">
          <div>
            <div class="item-title">{{ lang['withdrawn'] }}</div>
            <div class="item-value btc gold-gradient">
              <span>
                {{ withdrawn }} BTC
              </span>
            </div>
            <div class="item-value usd">&asymp; {{ withdrawnUsd }}</div>
            <div class="item-title">{{ lang['balance'] }}</div>
            <div class="item-value btc green-gradient">
              <span>
                {{ balance }} BTC
              </span>
            </div>
            <div class="item-value usd">&asymp; {{ balanceUsd }}</div>
          </div>

          <div class="buttons">
            <a href="javascript:void(0)" class="button btn btn-gold" @click="openWithdrawal()">
              {{ lang['withdrawNow'] }}
            </a>
            <router-link to="/withdrawals" class="button btn btn-simple">
              {{ lang['withdrawalHistory'] }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>